// 요금제·남은 한도 표시 (IMP-9)
//
// 429를 받고 나서야 한도를 알게 되는 UX를 피하려고 **미리** 보여준다.
import { QUOTA_LABELS, QUOTA_NOTES, type Usage } from "../api/billing.ts";

/** 남은 비율이 이 값 이하면 경고색으로 알린다 */
const WARN_RATIO = 0.2;

export function UsagePanel({ usage }: { usage: Usage }) {
  const price = usage.plan.monthlyPrice;

  return (
    <section className="panel usage-panel">
      <div className="usage-header">
        <h2>
          내 요금제 <span className="plan-badge">{usage.plan.name}</span>
        </h2>
        <p className="hint">
          {price === null
            ? "계약형 요금제 (한도 협의)"
            : price === 0
              ? "무료"
              : `월 ${price.toLocaleString("ko-KR")}원`}
        </p>
      </div>

      <ul className="quota-list">
        {usage.quotas.map((quota) => {
          const label = QUOTA_LABELS[quota.feature] ?? quota.feature;
          const note = QUOTA_NOTES[quota.feature];

          if (quota.limit === null) {
            return (
              <li key={quota.feature}>
                <span className="quota-label">{label}</span>
                <span className="quota-value">{quota.used.toLocaleString("ko-KR")} / 무제한</span>
              </li>
            );
          }

          // limit이 0이면 0으로 나누게 된다 → 미제공 기능으로 간주해 100%로 표시
          const usedRatio = quota.limit > 0 ? Math.min(1, quota.used / quota.limit) : 1;
          const low = quota.limit > 0 && (quota.remaining ?? 0) / quota.limit <= WARN_RATIO;

          return (
            <li key={quota.feature}>
              <span className="quota-label">{label}</span>
              <span className={low ? "quota-value quota-warn" : "quota-value"}>
                {quota.used.toLocaleString("ko-KR")} / {quota.limit.toLocaleString("ko-KR")}
              </span>
              {/* 진행 막대는 장식이므로 스크린리더에서 숨기고 위 텍스트를 정본으로 둔다 */}
              <span className="quota-bar" aria-hidden="true">
                <span
                  className={low ? "quota-bar-fill quota-bar-warn" : "quota-bar-fill"}
                  style={{ width: `${usedRatio * 100}%` }}
                />
              </span>
              {/* 좌석처럼 셈법이 직관과 다른 항목은 이유를 적어 준다 —
                  "멤버는 1명인데 왜 3석?"이 문의로 오지 않게 한다 */}
              {note && <span className="hint quota-note">{note}</span>}
            </li>
          );
        })}
      </ul>

      {!usage.features.ACCESS_CONTROL && (
        <p className="hint">
          만료일·클릭 제한·비밀번호는 Lite 이상 요금제에서 사용할 수 있습니다.
        </p>
      )}
    </section>
  );
}
